<template>
  <div id="centreLeft1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color: #5cd9e8">
          <!-- <icon name="chart-bar"></icon> -->
          <i class="iconfont icontingchechang11"></i>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">总数据报表</span>
          <dv-decoration-3
            style="
              width: 1.25rem;
              height: 0.25rem;
              position: relative;
              top: -0.0375rem;
            "
          />
        </div>
      </div>
      <div class="d-flex jc-center">
        <Echart
          :options="options"
          id="centreLeft1Chart"
          height="1.8rem"
          width="5rem"
        ></Echart>
      </div>
      <!-- 4个主要的数据 -->
      <div class="bottom-data">
        <div class="item-box" v-for="(item, index) in data" :key="index">
          <div class="d-flex">
            <ul>
              <li class="money" v-if="item.type == 1">
                <countTo
                    class="example3"
                    :start-val="item.values"
                    :end-val="item.value"
                    :duration="3000"
                    :decimals="0"
                    separator=","
                    :autoplay="true"
                  >
                  </countTo>
                </li>
                <li class="money" v-else>
                <countTo
                    class="example3"
                    :start-val="item.values"
                    :end-val="item.value"
                    :duration="3000"
                    :decimals="2"
                    separator=","
                    :autoplay="true"
                  >
                  </countTo>
                </li>
              <li class="text"> {{ item.name }} </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from "@/common/echart";
import countTo from "vue-count-to";
export default {
  data() {
    return {
      options: {},
      data:[
        {name:'现金总笔数',value:0,values:0,type:1},
        {name:'现金收费总额',value:0,values:0,type:0},
        {name:'电子支付总笔数',value:0,values:0,type:1},
        {name:'电子支付总额',value:0,values:0,type:0},
      ],
      cashAmount:0, // 现金支付总额
      epayAmount:0, // 电子支付总额
      amount:0, // 历史总金额
    };
  },
  components: {
    Echart,
    countTo
  },
  mounted() {
    this.submitGetMessageList();
  },
  methods: {
    charts() {
      // cashAmount+epayAmount
      var cash = ((this.cashAmount / (this.cashAmount+this.epayAmount)) * 100).toFixed(0);
      var epay = ((this.epayAmount / (this.cashAmount+this.epayAmount)) * 100).toFixed(0);
      var data = [
        {
          name: "现金收费金额",
          value: cash,
        },
        {
          name: "电子支付收费金额",
          value: epay,
        },
      ];
      var seriesArr = [];
      var colors = [
        ["#00cfff", "#dfeaff"],
        ["#ffdb5c", "#fdfdf2"],
      ];
      data.forEach(function (item, index) {
        seriesArr.push({
          name: item.name,
          type: "pie",
          clockWise: false,
          radius: [40, 46],
          itemStyle: {
            normal: {
              color: colors[index][0],
              shadowColor: colors[index][0],
              shadowBlur: 0,
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          hoverAnimation: false,
          center: [index * 52 + 25 + "%", "50%"],
          data: [
            {
              value: item.value,
              label: {
                normal: {
                  formatter: function (params) {
                    return params.value + "%";
                  },
                  position: "center",
                  show: true,
                  textStyle: {
                    fontSize: "20",
                    fontWeight: "bold",
                    color: colors[index][0],
                  },
                },
              },
            },
            {
              value: 100 - item.value,
              name: "invisible",
              itemStyle: {
                normal: {
                  color: colors[index][1],
                },
                emphasis: {
                  color: colors[index][1],
                },
              },
            },
          ],
        });
      });

      this.options = {
        backgroundColor: "",
        series: seriesArr,
      };
    },
    format(num) {
      // 数据千分位化
      return (num + "").replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
    },
    submitGetMessageList() {
      const that = this;
      that.$store.dispatch("getMessageList", 3); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
    },
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.reailTimeToal"(val) {
      //变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      var Amount = this.$store.state.historyTotal;
      var newAmount = val;
      this.cashAmount = Amount.cashAmount+newAmount.tempCash+newAmount.monthCash+newAmount.storeCash+newAmount.discountCash +120000000;
      this.epayAmount = Amount.epayAmount+newAmount.tempEpay+newAmount.monthEpay+newAmount.storeEpay+newAmount.discountEpay +60000000;
      var one = this.data[0].value;
      var tow = this.data[1].value;
      var three = this.data[2].value;
      var four = this.data[3].value;
      this.data[0].value = Amount.cashCount+newAmount.cashCount+1191500;
      this.data[1].value = this.cashAmount;
      this.data[2].value = Amount.epayCount+newAmount.epayCount+5000000;
      this.data[3].value = this.epayAmount;
      this.data[0].values = one;
      this.data[1].values = tow;
      this.data[2].values = three;
      this.data[3].values = four;
      this.amount = Amount;
      this.charts();
    },
  },
};
</script>

<style lang="scss">
@import "../assets/Digital/Digital.css";
#centreLeft1 {
  // padding: 0.1rem;
  height: 100%;
  min-width: 3.75rem;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 4.8125rem;
    border-radius: 0.125rem;

    .iconfont {
      color: #3ce2c5;
      font-size: 0.25rem;
    }
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }

  .bottom-data {
    .item-box {
      float: right;
      position: relative;
      width: 50%;
      color: #d3d6dd;
      .d-flex {
        height: 0.8rem;
      }
      .d-flex
      ul {
        width: 100%;
      }
      li {
        width:100%;
        text-align: center;
      }
      .money {
        display: inline-block;
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.3rem;
      }
      .text {
        display: inline-block;
        height: 0.4rem;
        line-height: 0.4rem;
      }
    }
  }
  .bottom-data>.item-box:first-child ul>li:first-child,
  .bottom-data>.item-box:nth-child(2) ul>li:first-child {
    color: #00cfff;
    font-family: Digital;
    font-weight: normal;
    letter-spacing:2px;
  }

  .bottom-data>.item-box:last-child ul>li:first-child,
  .bottom-data>.item-box:nth-child(3) ul>li:first-child {
    color: #ffdb5c;
    font-family: Digital;
    font-weight: normal;
    letter-spacing:2px;
  }
}
</style>